import type { CollectionCatalog } from '@/shared/variables/collections/clientes.collection'

/**
 * Colección CUOTAS: las cuotas del acuerdo de pago (`paymentAgreement.payments`,
 * tipo IPaymentDown). Es la SEGUNDA colección del motor — su sola existencia prueba
 * que el loop builder, el validador y el render ya no están casados con `clientes`.
 *
 * Dentro de un loop se usa como `cuota.numero`, `cuota.monto`, `cuota.fecha`, etc.
 * Las máscaras se aplican a nivel de uso (el chip elige `currency`/`dateLetters`).
 */
export const CUOTAS_COLLECTION: CollectionCatalog = {
  name: 'cuotas',
  defaultAlias: 'cuota',
  label: 'Cuotas (acuerdo de pago)',
  fields: [
    { key: 'numero', label: 'Número de cuota', type: 'number' },
    { key: 'monto', label: 'Monto', type: 'number', mask: 'currency' },
    { key: 'mejora', label: 'Mejora (upgrade)', type: 'number', mask: 'currency' },
    { key: 'fecha', label: 'Fecha de pago', type: 'date', mask: 'dateNumbers' },
    { key: 'comentario', label: 'Comentario', type: 'string' }
  ],
  demo: [
    { numero: '1', monto: '50000.00', mejora: '0.00', fecha: '2026-08-01', comentario: 'Enganche' },
    { numero: '2', monto: '25000.00', mejora: '0.00', fecha: '2026-09-01', comentario: '' },
    { numero: '3', monto: '25000.00', mejora: '0.00', fecha: '2026-10-01', comentario: '' }
  ]
}
